module.exports = __webpack_public_path__ + "static/media/notices-icon-active.e629f5c3.svg";